import React, { useEffect, memo } from 'react';

import { App } from 'antd';

import TopPage from 'v2/components/Shared/TopPage';
import affiliationsService from 'v2/services/affiliations';

import { List } from './List';

const Affiliations = () => {
  const { message } = App.useApp();

  useEffect(() => {
    const subscription = affiliationsService.loadAffiliations().subscribe({
      error: error => message.error(error instanceof Error ? error.message : 'Erro ao carregar afiliações')
    });

    return () => subscription.unsubscribe();
  }, [message]);

  return (
    <>
      <TopPage title='Minhas Afiliações' extra='Gerencie suas afiliações.' disableAlerts />
      <List />
    </>
  );
};

export default memo(Affiliations);
